import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'

import DirectReports from './DirectReports'
import Overview from './Overview'

const ReportsDetails = ({ contractVersions }: { contractVersions: ContractVersions }) => {
  return (
    <Box>
      <Overview />

      <DirectReports contractVersions={contractVersions} />
    </Box>
  )
}

export default ReportsDetails
